export default __webpack_public_path__ + "static/media/phoenix-logo.daba2437.png";